shipping();

function shipping() {
	//const shippingCalc = document.getElementById("shippingCalculator");
	const showShippingCalcBtn = document.getElementById("showShippingCalcBtn");
	const shippingCalcContent = document.getElementById("shippingCalcContent");
	const closeButton = shippingCalcContent.querySelector("button");

	// "Show the dialog" button opens the dialog modally
	showShippingCalcBtn.addEventListener("click", () => {
		shippingCalcContent.classList.add("shipping-calculator__form--active");
	});

	//"Close" button closes the dialog
	closeButton.addEventListener("click", () => {
		shippingCalcContent.classList.remove("shipping-calculator__form--active");
	});
}